import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SectionItemDto } from '../../../core/models/cms.model';
import { FEATURE_GRID_6_SLOTS, DEFAULT_FIGMA_HOME_ASSETS, GridSlotPreset } from '../../../core/constants/grid-layout-presets';
import { mediaProfileForSlotHint, sizesForSlotHint } from '../../../core/utils/media-image-profile.util';
import { MediaSrcDirective } from '../../directives/media-src.directive';
import { MediaSlotComponent } from '../media-slot/media-slot.component';

@Component({
  selector: 'app-feature-grid-6',
  standalone: true,
  imports: [CommonModule, RouterModule, MediaSrcDirective, MediaSlotComponent],
  templateUrl: './feature-grid-6.component.html',
  styleUrls: ['./feature-grid-6.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureGrid6Component {
  readonly slots = FEATURE_GRID_6_SLOTS;

  @Input({ required: true }) items: SectionItemDto[] = [];
  @Input() zoomOnClick = false;
  @Output() cellActivate = new EventEmitter<{ mediaUrl: string; mediaType: 'image' | 'video'; title: string }>();

  mediaProfileForSlot(slot: GridSlotPreset) {
    return mediaProfileForSlotHint(slot.hintPx);
  }

  sizesForSlot(slot: GridSlotPreset): string {
    return sizesForSlotHint(slot.hintPx);
  }

  cellItem(sortOrder: number): SectionItemDto | undefined {
    const existing = this.items.find((i) => i.sortOrder === sortOrder);
    const fallbackUrl = DEFAULT_FIGMA_HOME_ASSETS.featureGrid6[sortOrder] || '';
    if (!existing?.mediaUrl?.trim() && fallbackUrl) {
      return {
        ...existing,
        id: existing?.id ?? -(sortOrder + 1),
        sortOrder,
        mediaType: 'image',
        mediaUrl: fallbackUrl,
      };
    }
    return existing;
  }

  cellLink(item: SectionItemDto | undefined): string | null {
    if (this.zoomOnClick) {
      return null;
    }
    const url = item?.linkUrl?.trim();
    return url || null;
  }

  onCellActivate(item: SectionItemDto): void {
    if (!this.zoomOnClick || !item.mediaUrl?.trim()) {
      return;
    }
    this.cellActivate.emit({
      mediaUrl: item.mediaUrl,
      mediaType: item.mediaType === 'video' ? 'video' : 'image',
      title: item.title || '',
    });
  }

  onCellKeydown(event: KeyboardEvent, item: SectionItemDto): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onCellActivate(item);
    }
  }

  trackBySortOrder(_: number, slot: (typeof FEATURE_GRID_6_SLOTS)[number]): number {
    return slot.sortOrder;
  }
}
